import client from "utils/api";
import store from 'utils/store'
import { normalize, schema } from 'normalizr';

function getAccounts(){
  return client().get(`/accounts`)
    .then((response) => {
      const account = new schema.Entity('accounts');
      const normalizedData = normalize(response.data, [account]);
      store.dispatch({type:"SET_ACCOUNTS", payload: normalizedData.entities.accounts})
      return response.data
    })
}
function getAccount(id){
  return client().get("/accounts/"+id)
    .then((response) => {
      const account = new schema.Entity('accounts');
      const normalizedData = normalize(response.data, account);
      store.dispatch({type:"ADD_ACCOUNT", payload: normalizedData.entities.accounts})
      return response.data
    })
}


export default {
  getAccounts,
  getAccount
}



// WEBPACK FOOTER //
// ./src/components/accounts_page/api.js